import React, { Suspense } from 'react'
import { Route } from 'react-router-dom'
import { MainHeader } from '../../../global/nav/components/MainHeader'
import { MainLayout } from '../../../global/nav/components/MainLayout'
import { Props } from '../../../modules/types'
import SuspenseFallback from '../../../components/layout/SuspenseFallback'

function AdminRoute(props: Props) {
  const { component: Component, breadcrumbInfo, ...rest } = props

  return (
    <Route {...rest} render={matchProps => (
      <MainLayout>
        <MainHeader breadcrumbInfo={breadcrumbInfo} />
        <Suspense fallback={<SuspenseFallback />}>
        <Component {...matchProps} />
        </Suspense>
      </MainLayout>
    )} />
  )
}

export default AdminRoute
